import { useAuth } from 'context/authentication/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import LoadingScreen from '../../../components/Layout/LoadingScreen'
import { MobileUnauthenticatedNav } from 'components/Layout/Navbar/MobileUnauthenticatedNav'
import { MobileUnauthenticatedFooter } from 'components/Layout/Footer/MobileFooter'

export function MobileAuthLayout() {
  const { isAuthenticated, isCheckingAuth } = useAuth()

  if (isCheckingAuth) return <LoadingScreen />

  if (isAuthenticated) return <Navigate to="/" />

  return (
    <main className="flex flex-col items-stretch bg-white h-dvh w-full">
      <MobileUnauthenticatedNav />
      <div className="flex-1 w-full flex flex-col justify-center px-6 bg-surface-sunken">
        <Outlet />
      </div>
      <MobileUnauthenticatedFooter />
    </main>
  )
}
